import { render } from "./IntegrationCard.vue?vue&type=template&id=29c169b6&scoped=true&ts=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=ts"
export * from "./IntegrationCard.vue?vue&type=script&lang=ts"

import "./IntegrationCard.vue?vue&type=style&index=0&id=29c169b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c169b6"]])

export default __exports__